import { allBlogs } from "../../Data/BlogData";
import { Link } from "react-router-dom";
import '../../Component/blog.css';


const HomeBlogs = () => {
    const latestBlogs = allBlogs
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .slice(0, 3);

    return (
   <section className="blog-section Teachers">
            <div className="container">
                <div
                    className="d-flex justify-content-center align-items-center text-center flex-column mx-auto"
                    data-aos="fade-up"
                >
                    <h2 className="mb-3 mt-0">Our Blogs</h2>
                </div>

                <div
                    className="blog-posts"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                    data-aos-duration="800"
                >
                    <div className="row">
                        {latestBlogs.map((blog, index) => (
                            <div key={blog.id} className="col-lg-4 col-md-6 col-sm-6 d-flex mt-3">
                                <div
                                    className="blog-post h-100 d-flex flex-column"
                                    data-aos="zoom-in-up"
                                    data-aos-delay={index * 100}
                                    data-aos-duration="800"
                                >
                                    <div className="blog-thumbnail">
                                        <img
                                            src={`/assets/images/Courses/${blog.mainImage}`}
                                            alt={blog.title}
                                            className="w-100"
                                        />
                                        <span className="category">English</span>
                                    </div>

                                    {/* Content */}
                                    <div className="blog-info d-flex flex-column flex-grow-1">
                                        <ul className="meta d-flex">
                                            <li>
                                                <span className="me-1">{blog.date}</span>
                                            </li>
                                            <li>
                                                <span className="me-1">by Admin</span>
                                            </li>
                                        </ul>

                                        <h3 className="text-warning">
                                            <Link to={`/blog/${blog.instituteId}/${blog.slug}`}>
                                                {blog.title}
                                            </Link>
                                        </h3>

                                        <p className="flex-grow-1">
                                            {blog.excerpt || blog.metaDescription}
                                        </p>

                                        <Link
                                            to={`/blog/${blog.instituteId}/${blog.slug}`}
                                            className="read-more border-black mt-auto"
                                        >
                                            Read <i className="fa fa-long-arrow-alt-right" />
                                        </Link>
                                    </div>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>
                {/* blog-posts end */}
            </div>
  </section>
    );
};

export default HomeBlogs;
